/* eslint-disable arrow-body-style */
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useActions } from '../../providers/actions-provider/actions.context';

export const useGetUserDetails = (): void => {
  const { userActions, tenantActions, facilityActions } = useActions();
  const { id } = useParams<{id:string}>();

  useEffect(() => {
    userActions.getPickedUser(+id);
    userActions.getRolesList();
    userActions.getTimeZones();
    tenantActions.getTenantsList();
    facilityActions.getFacilities();
    facilityActions.getGroups();
  }, []);

  // if (currentUser.data.id === +id) {
  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   useEffect(() => {
  //     return () => {
  //       userActions.getPickedUser(+id);
  //     };
  //   }, []);
  // }
};

export default useGetUserDetails;
